import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M775.08,61.65c-7.7-5.54-19.09-6.16-30.48-1.85L22.43,348.85c-7.7,10.78-12.01,26.47.62,37.56l197.94,78.8,56.02,205.02c6.46,11.08,12.93,15.39,24,15.7h.32c14.47,0,47.71-26.16,72.34-45.25,28-22.16,42.78-33.25,52.94-33.25h2.16l2.77,1.23,192.7,131.44c8.01,3.39,16.94,4,24.32.92,6.78-3.08,12.01-9.23,15.09-17.85l121.28-639.06c.32-9.23-3.08-17.55-9.85-22.47ZM282.24,486.15c-3.08-8.62-4.92-17.24-6.78-25.55-2.15-9.85-4.3-20.01-7.7-26.16-7.7-14.47-52.01-29.24-84.65-39.71-20.92-7.08-39.08-12.93-49.86-19.09l-14.16-7.7,519-208.4-339.85,334.92-2.47.31c-.62.31-1.85.62-3.38.62-1.85,0-4-.62-6.16-1.85-3.08-2.46-3.68-5.85-4-7.39ZM316.1,619.13l-24.62-104.97,86.19,55.72-61.57,49.25ZM619.32,671.15l-253.66-175.77,352.47-336.77-98.81,512.54Z"
	})
});
export default SvgSend;
